/**
 * @generated SignedSource<<29b01e339073e0a6d67760e568283ac9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WeekPreview_viewer$data = {
  readonly settings: {
    readonly timezonePreferences: {
      readonly extraTimezones: ReadonlyArray<{
        readonly timezone: {
          readonly name: string;
        };
        readonly userLabel: string;
      } | null>;
      readonly preferredTimezone: {
        readonly timezone: {
          readonly name: string;
        };
        readonly userLabel: string;
      };
    };
  };
  readonly " $fragmentSpreads": FragmentRefs<"usePreferredTimezone_viewer">;
  readonly " $fragmentType": "WeekPreview_viewer";
};
export type WeekPreview_viewer$key = {
  readonly " $data"?: WeekPreview_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"WeekPreview_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "userLabel",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "TimeZone",
    "kind": "LinkedField",
    "name": "timezone",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WeekPreview_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePreferredTimezone_viewer"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserSettings",
      "kind": "LinkedField",
      "name": "settings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TimezonePreferences",
          "kind": "LinkedField",
          "name": "timezonePreferences",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "UserTimezone",
              "kind": "LinkedField",
              "name": "preferredTimezone",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "UserTimezone",
              "kind": "LinkedField",
              "name": "extraTimezones",
              "plural": true,
              "selections": (v0/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "a19d5d6547df92f9fccf3f78ceed6963";

export default node;
